import { ShowroomApplicationState } from '../enum';

export const BUYER_FIELDS = 'buyer.';
export const VEHICLE_FIELDS = 'vehicle';
export const CHECK_REQUIRED_FIELDS = [BUYER_FIELDS, VEHICLE_FIELDS];

export const DEFAULT_STATE = ShowroomApplicationState.IN_PROGRESS;

export const DEAL_MAKER = 'Dealmaker';
export const DEALER = 'Dealer';
